import styled from 'styled-components';

import { Breadcrumb } from '@components/breadcrumb';
import { ExpandableSearch } from '@components/expandable-search';
import { UseFiltersValue } from '@components/filters';
import { SearchBox } from '@components/search-box';
import { Stack } from '@components/stack';

import { Box } from 'components/Box';
import { FilterButton } from 'components/FilterButton';
import { Header } from 'components/headers';
import { FilterState } from 'features/filters/create-filter-state-hook';

type FilterActionProps = {
  filters?: UseFiltersValue;
  filterState: FilterState;
  searchPlaceholder: string;
  isSearchExpanded?: boolean;
};

type FilterHeaderProps = FilterActionProps & {
  title: string;
  tabs?: JSX.Element;
};

export const FilterHeader: React.FC<FilterHeaderProps> = ({
  title,
  filters,
  filterState,
  searchPlaceholder,
  isSearchExpanded,
  children,
  ...rest
}) => (
  <Header
    // @ts-ignore
    breadcrumbs={<Breadcrumb items={[{ label: title }]} />}
    mobileTitle={title}
    actions={
      <FilterActions
        filters={filters}
        filterState={filterState}
        searchPlaceholder={searchPlaceholder}
        isSearchExpanded={isSearchExpanded}
      >
        {children}
      </FilterActions>
    }
    {...rest}
  />
);

const FilterActions: React.FC<FilterActionProps> = ({
  children,
  searchPlaceholder,
  filters,
  filterState,
  isSearchExpanded,
}) => (
  <ActionsContainer flex justifyContent="space-between" backgroundColor="white100">
    <Stack orientation="horizontal" space={2} justify="flex-end">
      {isSearchExpanded ? (
        <SearchBox
          value={filterState.search}
          onChange={filterState.setSearchValue}
          placeholder={searchPlaceholder}
        />
      ) : (
        <ExpandableSearch
          value={filterState.search}
          onChange={filterState.setSearchValue}
          onChangeDebounce={0}
          placeholder={searchPlaceholder}
        />
      )}
      {children}
      {filters && <FilterButton filters={filters} />}
    </Stack>
  </ActionsContainer>
);

const ActionsContainer = styled(Box).attrs({
  flex: true,
})({
  '@media(max-width: 480px)': {
    flexWrap: 'wrap-reverse',
  },
});
